/**
 * Previously Mixpanel was used track different actions,
 * maybe in future it will be reused or another provider
 */
export const AnalyticsService = {
  identify: (id) => {
    // mixpanel.identify(id);
  },
  alias: (id) => {
    // mixpanel.alias(id);
  },
  track: (name, props) => {
    // mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      // mixpanel.people.set(props);
    },
  },
};
